module.exports = __webpack_public_path__ + "1f80782e11ba3c1bd6ddb49d5d4c60d9.png";